import { MODAL_Z_INDEX } from '@/constants/zIndex';

// Modals are raised just above the automation underway popup (and every drawer)
// so any modal always covers it, while staying below `popover` (1500) so
// Popover/Menu/Select inside a modal keep working. See src/constants/zIndex.ts.
// The overlay AND the positioning container (`dialogContainer`) must move
// together — raising the overlay alone would leave it above the dialog and
// blacken the modal.

const baseStyleOverlay = {
  bg: 'rgba(22, 22, 22, 0.7)',
  backdropFilter: 'blur(1px)',
  zIndex: MODAL_Z_INDEX,
};

const baseStyleDialogContainer = {
  zIndex: MODAL_Z_INDEX,
};

const baseStyleDialog = (props) => {
  const { scrollBehavior } = props;

  return {
    borderRadius: '16px',
    color: 'inherit',
    my: '3.75rem',
    zIndex: MODAL_Z_INDEX,
    maxH: scrollBehavior === 'inside' ? 'calc(100% - 7.5rem)' : undefined,
    boxShadow: '0px 4px 12px 6px rgba(46, 47, 48, 0.06)',
    border: '1px solid',
    borderColor: 'modal-border',
  };
};

const baseStyleCloseButton = {
  position: 'absolute',
  top: '12px',
  right: '12px',
  insetEnd: 3,
  bg: 'secondary-50',
  borderRadius: '8px',
  _focus: { outline: 'none' },
  _active: { bg: 'none !important' },
  svg: {
    bg: 'secondary-50',
    width: '10px',
    height: '10px',
    color: 'secondary-700',
  },
};

const baseStyle = (props) => ({
  overlay: baseStyleOverlay,
  dialogContainer: baseStyleDialogContainer,
  dialog: baseStyleDialog(props),
  closeButton: baseStyleCloseButton,
});

export const Modal = {
  baseStyle,
};
